/* Volta custom cart drawer — v0 logic */
(function () {
  "use strict";

  var internalAdd = false;

  function clearThemeLock() {
    var h = document.documentElement, b = document.body;
    ["overflow-hidden", "scroll-lock", "no-scroll", "drawer-open", "js-drawer-open", "cart-open", "overflow-hidden-tablet", "overflow-hidden-mobile", "lock-scroll", "scroll-locked", "drawer-open--cart"].forEach(function (cls) { h.classList.remove(cls); b.classList.remove(cls); });
    if (b.style.position === "fixed") {
      var top = parseInt(b.style.top || "0", 10);
      b.style.position = ""; b.style.top = ""; b.style.left = ""; b.style.right = ""; b.style.width = "";
      if (top) window.scrollTo(0, Math.abs(top));
    }
    if (b.style.overflow === "hidden") b.style.overflow = "";
    if (h.style.overflow === "hidden") h.style.overflow = "";
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("cart-drawer").then(function () {
      var CD = customElements.get("cart-drawer");
      if (CD && CD.prototype && !CD.prototype.__ccPatched) {
        CD.prototype.__ccPatched = true;
        CD.prototype.show = function () {
          document.dispatchEvent(new Event("cart::refresh"));
          document.dispatchEvent(new Event("cart::open"));
        };
      }
    }).catch(function () {});
  }

  (function () {
    var _fetch = window.fetch;
    if (_fetch && !_fetch.__ccWrapped) {
      var wrapped = function (input, init) {
        var url = (typeof input === "string") ? input : (input && input.url) || "";
        var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
        var p = _fetch.apply(this, arguments);
        if (isAdd && !internalAdd) {
          p.then(function (res) {
            if (res && res.ok) {
              document.dispatchEvent(new Event("cart::refresh"));
              document.dispatchEvent(new Event("cart::open"));
            }
          }).catch(function () {});
        }
        return p;
      };
      wrapped.__ccWrapped = true;
      window.fetch = wrapped;
    }
  })();

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!document.querySelector("custom-cart")) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    if (idInput && !fd.get("id")) fd.append("id", idInput.value);
    internalAdd = true;
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: fd })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { internalAdd = false; document.dispatchEvent(new Event("cart::refresh")); document.dispatchEvent(new Event("cart::open")); })
      .catch(function (err) { internalAdd = false; console.error("[cc] form add", err); });
  }, true);

  var money = function (cents) {
    var data = cartData();
    var cartCur = (data && data.currency) || "USD";
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || cartCur;
    var rate = (active !== cartCur && window.Shopify && Shopify.currency && Shopify.currency.rate) ? parseFloat(Shopify.currency.rate) : 1;
    var amount = (Math.round(cents) * rate) / 100;
    return "$" + amount.toFixed(2) + " " + active;
  };

  function readJSON(sel, root) {
    try {
      var el = (root || document).querySelector(sel);
      return el ? JSON.parse(el.textContent || "{}") : null;
    } catch (e) { return null; }
  }
  function cfg() { return readJSON("#volta-tier-config") || {}; }
  /* 0.314 → "31", 0.386 → "39", 0.44 → "44" — whole percents */
  function pctLabel(x) { return String(Math.round(x * 100)); }
  function cartData() { return readJSON(".cc-cart-data") || { items: [], total_price: 0 }; }

  function canVariantIds() { return (cfg().variants || []).map(function (v) { return Number(v.id); }); }
  function isCanLine(it, canIds) { return !it.is_gift && canIds.indexOf(Number(it.variant_id)) !== -1; }
  function totalCans(data) {
    var ids = canVariantIds();
    return (data.items || []).reduce(function (s, it) { return s + (isCanLine(it, ids) ? it.quantity : 0); }, 0);
  }
  function isSubscription(data) {
    var ids = canVariantIds();
    return (data.items || []).some(function (it) { return isCanLine(it, ids) && it.selling_plan; });
  }
  function tiersFor(sub) { var c = cfg(); return sub ? (c.subTiers || []) : (c.oneTimeTiers || []); }
  function tierFor(n, sub) {
    var a = tiersFor(sub).filter(function (t) { return n >= t.min && n <= t.max; });
    return a[0] || null;
  }
  function savingsCents(data) {
    return (data.items || []).reduce(function (s, it) {
      var before = (it.unit_before != null) ? it.unit_before : (it.original_price || 0);
      var per = before - (it.final_price || 0);
      return s + (per > 0 ? per * it.quantity : 0);
    }, 0);
  }

  function addBusinessDays(date, n) {
    var d = new Date(date), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }); }

  var CartCustomRemove = class extends HTMLElement {
    constructor() {
      super();
      var self = this;
      var fire = function (ev) {
        ev.preventDefault();
        var cart = self.closest("custom-cart");
        var line = parseInt(self.getAttribute("data-index"), 10);
        if (cart && Number.isFinite(line)) cart.changeLine(line, 0);
      };
      this.addEventListener("click", fire);
      this.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") fire(e); });
    }
  };
  if (!customElements.get("cart-custom-remove")) customElements.define("cart-custom-remove", CartCustomRemove);

  class CustomCart extends HTMLElement {
    constructor() {
      super();
      this._busy = false;
      this._syncing = false;
      this._qtyTimer = null;
      this._pendingQty = null;
      this._refreshing = null;
      this._refreshQueued = false;
    }

    connectedCallback() {
      if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
      if (this._inited) return;
      this._inited = true;

      var self = this;
      this.querySelector("[data-cc-overlay]") && this.querySelector("[data-cc-overlay]").addEventListener("click", function () { self.close(); });
      this.addEventListener("click", function (e) {
        if (e.target.closest("[data-cc-close]")) { e.preventDefault(); self.close(); return; }
        var plus = e.target.closest("[data-cc-plus]"), minus = e.target.closest("[data-cc-minus]");
        if (plus || minus) {
          var wrap = (plus || minus).closest(".cc__qty"); if (!wrap) return;
          var input = wrap.querySelector(".cc__qty-input"); if (!input) return;
          var line = parseInt(input.getAttribute("data-line"), 10);
          var q = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
          if (q < 0) q = 0;
          q = self._clampMin(line, q);
          input.value = q;
          self._queueQty(line, q);
          return;
        }
        var upAdd = e.target.closest("[data-cc-upsell-add]");
        if (upAdd) { e.preventDefault(); self.addUpsell(Number(upAdd.getAttribute("data-variant-id"))); return; }
        var doSwitch = e.target.closest("[data-cc-do-switch]");
        if (doSwitch) { e.preventDefault(); self.switchToSubscription(); return; }
      });
      this.addEventListener("change", function (e) {
        var input = e.target.closest(".cc__qty-input"); if (!input) return;
        var line = parseInt(input.getAttribute("data-line"), 10);
        var q = parseInt(input.value, 10); if (!Number.isFinite(q) || q < 0) q = 0;
        q = self._clampMin(line, q);
        input.value = q;
        self._queueQty(line, q);
      });

      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && self.classList.contains("open")) self.close(); });
      document.addEventListener("click", function (e) {
        if (!self.classList.contains("open")) return;
        if (e.target.closest(".cc__panel")) return;
        if (e.target.closest('[aria-controls="CartDrawer"], .cart-drawer-button, [data-cc-open]')) return;
        self.close();
      });
      document.addEventListener("cart::open", function () { self.open(); });
      document.addEventListener("cart::refresh", function () { self.refresh(); });

      this.render();
      this.reconcile();

      try {
        if (sessionStorage.getItem("cc_open")) {
          sessionStorage.removeItem("cc_open");
          self.open();
          self.refresh();
        }
      } catch (e) {}
    }

    open() { this.classList.add("open"); document.documentElement.classList.add("cc-lock"); this.render(); }
    close() { this.classList.remove("open"); document.documentElement.classList.remove("cc-lock"); clearThemeLock(); }

    _clampMin(line, quantity) {
      var data = cartData(), items = data.items || [], it = items[line - 1];
      if (!it) return quantity;
      var ids = canVariantIds();
      if (it.is_gift || ids.indexOf(Number(it.variant_id)) === -1) return quantity;
      var min = cfg().minCans || 3;
      var otherSum = totalCans(data) - it.quantity;
      var floor = Math.max(0, min - otherSum);
      return Math.max(quantity, floor);
    }

    _queueQty(line, quantity) {
      var self = this;
      this._pendingQty = { line: line, quantity: quantity };
      clearTimeout(this._qtyTimer);
      this._qtyTimer = setTimeout(function () {
        var pq = self._pendingQty; self._pendingQty = null;
        if (pq) self.changeLine(pq.line, pq.quantity);
      }, 280);
    }

    changeLine(line, quantity) {
      var self = this;
      if (this._busy) return Promise.resolve();
      this._busy = true;
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { if (!r.ok) throw new Error("change " + r.status); return r.json(); })
        .then(function () { return self.refresh(); })
        .catch(function (err) { console.error("[cc] changeLine", err); })
        .finally(function () { self._busy = false; });
    }

    addUpsell(variantId) {
      if (!variantId) return;
      var self = this, data = cartData(), c = cfg();
      var body = { id: variantId, quantity: 1 };
      if (isSubscription(data)) {
        var t = tierFor(totalCans(data), true);
        if (t && c.subPlans && c.subPlans[t.key]) body.selling_plan = c.subPlans[t.key];
      }
      fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { return self.refresh(); })
        .catch(function (e) { console.error("[cc] upsell add", e); });
    }

    switchToSubscription() {
      var self = this, data = cartData(), c = cfg();
      var sub = tierFor(totalCans(data), true);
      if (!sub || !c.subPlans || !c.subPlans[sub.key]) return;
      var plan = c.subPlans[sub.key], ids = canVariantIds();
      var lines = (data.items || []).filter(function (it) { return isCanLine(it, ids); });
      var chain = Promise.resolve();
      lines.forEach(function (it) {
        chain = chain.then(function () {
          return fetch("/cart/change.js", {
            method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: plan })
          });
        });
      });
      chain.then(function () { return self.refresh(); }).catch(function (e) { console.error("[cc] switch", e); });
    }

    refresh() {
      var self = this;
      if (this._refreshing) { this._refreshQueued = true; return this._refreshing; }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      this._refreshing = fetch(root + "?sections=section-custom-cart", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data["section-custom-cart"];
          if (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            ["[data-cc-content]", "[data-cc-foot]"].forEach(function (sel) {
              var next = doc.querySelector(sel), cur = self.querySelector(sel);
              if (next && cur) cur.replaceWith(next.cloneNode(true));
            });
            [".cc-cart-data", ".cc-gift-rules"].forEach(function (sel) {
              var next = doc.querySelector(sel), cur = document.querySelector(sel);
              if (next && cur) cur.textContent = next.textContent;
            });
          }
          var count = cartData().item_count || 0;
          self.setAttribute("data-count", count);
          self.querySelectorAll("[data-cc-count]").forEach(function (el) { el.textContent = count; });
          document.querySelectorAll("cart-count").forEach(function (cc) {
            cc.textContent = count;
            if (count > 0) cc.removeAttribute("hidden"); else cc.setAttribute("hidden", "");
          });
          self.render();
          self.reconcile();
        })
        .catch(function (err) { console.error("[cc] refresh", err); })
        .finally(function () {
          self._refreshing = null;
          if (self._refreshQueued) { self._refreshQueued = false; self.refresh(); }
        });
      return this._refreshing;
    }

    render() {
      var data = cartData();
      var sub = isSubscription(data), cans = totalCans(data), tier = tierFor(cans, sub);
      this.renderTiers(data, sub, cans, tier);
      this.renderSavings(data);
      this.renderSwitch(data, sub, cans);
      this.renderUpsell(data);
      this.renderDelivery(data);
      this.renderCheckoutGuard(data);
    }

    renderUpsell(data) {
      var el = this.querySelector("[data-cc-upsell]"); if (!el) return;
      var pid = Number(el.getAttribute("data-upsell-product-id"));
      var inCart = pid && (data.items || []).some(function (it) { return Number(it.product_id) === pid; });
      el.style.display = inCart ? "none" : "";
      if (inCart) return;

      var priceEl = el.querySelector("[data-cc-upsell-price]");
      var base = Number(el.getAttribute("data-price")) || 0;
      if (!priceEl || !base) return;
      var sub = isSubscription(data);
      var tier = tierFor(totalCans(data) + 1, sub);
      var disc = tier ? (tier.disc || 0) : 0;
      var now = Math.round(base * (1 - disc));
      var html = '<span class="cc-upsell__now">' + money(now) + '</span>';
      if (disc > 0) {
        html += '<s>' + money(base) + '</s>' +
                '<span class="cc__off">' + Math.round(disc * 100) + '% OFF</span>';
      }
      priceEl.innerHTML = html;
    }

    renderTiers(data, sub, cans, tier) {
      var box = this.querySelector("[data-cc-tiers]"); if (!box) return;
      var tiers = tiersFor(sub);
      if (!tiers.length) { box.innerHTML = ""; return; }
      var track = tiers.map(function (t) {
        var active = tier && t.min === tier.min;
        /* NOV 2026: чип = общая скидка с учётом подарочных банок (6+1 → 31.4%, 9+2 → 38.6%, 12+3 → 44%) */
        var eff = 1 - (1 - (t.disc || 0)) * t.min / (t.min + (t.gift || 0));
        var top = eff > 0 ? (pctLabel(eff) + "% OFF") : (t.min + " Cans");
        return '<span class="cc-tier__pct' + (active ? " is-active" : "") + '">' + top + '</span>';
      }).join("");
      var subs = tiers.map(function (t) {
        var active = tier && t.min === tier.min;
        var pct = Math.round((t.disc || 0) * 100);
        var sub2 = pct ? (t.gift ? (t.min + "+" + t.gift + " Free") : (t.min + " Cans")) : "";
        return '<span class="cc-tier__sub' + (active ? " is-active" : "") + '">' + sub2 + '</span>';
      }).join("");
      box.innerHTML =
        '<div class="cc-tiers__track">' + track + "</div>" +
        '<div class="cc-tiers__subs">' + subs + "</div>";
    }

    renderSavings(data) {
      var el = this.querySelector("[data-cc-savings]"); if (!el) return;
      var s = savingsCents(data);
      if (s > 0) { el.hidden = false; el.innerHTML = "<span>Your Savings</span><span class=\"cc__savings-val\">" + money(s) + "</span>"; }
      else { el.hidden = true; el.innerHTML = ""; }
    }

    renderSwitch(data, sub, cans) {
      var el = this.querySelector("[data-cc-switch]"); if (!el) return;
      var min = cfg().minCans || 3;
      if (sub || cans < min) { el.hidden = true; el.innerHTML = ""; return; }
      var subTier = tierFor(cans, true);
      var pct = subTier ? Math.round((subTier.disc || 0) * 100) : 0;
      el.hidden = false;
      el.innerHTML =
        '<div class="cc-switch">' +
          '<div class="cc-switch__text"><strong><svg class="cc-switch__ic" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20h16M6 20v-5M11 20V9M16 20v-8M21 20V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg> Switch to subscription &amp; SAVE ' + pct + '%</strong>' +
          '<small>Never run out of Volta. Skip or cancel anytime.</small></div>' +
          '<button type="button" class="cc-switch__btn" data-cc-do-switch>Switch &amp; Save</button>' +
        '</div>';
    }

    renderDelivery(data) {
      var el = this.querySelector("[data-cc-delivery]"); if (!el) return;
      if (el.getAttribute("data-enabled") === "0") { el.hidden = true; el.innerHTML = ""; return; }
      var country = (data.country || this.getAttribute("data-market") || "").toUpperCase();
      if (country !== "US") { el.hidden = true; el.innerHTML = ""; return; }
      var from = addBusinessDays(new Date(), 5), to = addBusinessDays(new Date(), 7);
      el.hidden = false;
      el.innerHTML = '<svg class="cc__truck" width="16" height="16" viewBox="0 0 17 17" fill="none" aria-hidden="true"><path d="M11.6715 8.72843C11.3794 8.72843 11.1403 8.48936 11.1403 8.19718C11.1403 7.905 11.3794 7.66593 11.6715 7.66593H13.8072L12.2878 5.60468C12.1869 5.46655 12.0275 5.38688 11.8575 5.38688H10.71V4.78125C10.71 4.48907 10.4709 4.25 10.1787 4.25H8.97282C8.98874 4.35626 8.99938 4.4678 8.99938 4.57937V7.31529C8.99938 8.00594 8.62749 8.64873 8.02186 8.98874C7.42155 9.32875 6.68313 9.31811 6.08814 8.96218L5.88626 8.84001L5.68438 8.96218C5.38157 9.14279 5.03624 9.23313 4.69626 9.23313C4.36686 9.23313 4.0428 9.15343 3.75062 8.98874C3.15031 8.64873 2.77311 8.00594 2.77311 7.31529V4.57937C2.77311 4.4678 2.78374 4.35626 2.7997 4.25H1.59375C1.30157 4.25 1.0625 4.48907 1.0625 4.78125V11.6131C1.0625 11.9053 1.30157 12.1444 1.59375 12.1444H2.91124C3.12907 12.8031 3.74531 13.2812 4.47312 13.2812C5.19564 13.2812 5.81188 12.8031 6.03499 12.1444H11.2306C11.4484 12.8031 12.07 13.2812 12.7925 13.2812C13.515 13.2812 14.1366 12.8031 14.3544 12.1444H15.4062C15.6984 12.1444 15.9375 11.9053 15.9375 11.6131V8.72843H11.6715Z" fill="currentColor"/><path d="M4.27157 8.06437C4.40438 8.13875 4.54783 8.17063 4.69659 8.17063C4.85064 8.17063 5.00469 8.13344 5.13751 8.05374L5.88659 7.60219L6.63564 8.05374C6.90126 8.20782 7.23063 8.2131 7.50158 8.06437C7.7672 7.91032 7.9372 7.62342 7.9372 7.31529V4.57937C7.9372 4.10123 7.5494 3.71875 7.07658 3.71875H4.69659C4.22377 3.71875 3.83594 4.10123 3.83594 4.57937V7.31529C3.83594 7.62342 4.00594 7.91032 4.27157 8.06437Z" fill="currentColor"/></svg> Estimated delivery: <strong>' + fmtDate(from) + " - " + fmtDate(to) + "</strong>";
    }

    renderCheckoutGuard(data) {
      var checkout = this.querySelector(".cc__checkout"); if (!checkout) return;
      var label = checkout.querySelector(".cc__checkout-label");
      var total = checkout.querySelector(".cc__checkout-total");
      var cans = totalCans(data), min = cfg().minCans || 3;
      var below = cans > 0 && cans < min;
      checkout.classList.toggle("is-disabled", below);
      if (below) {
        if (label) label.textContent = "ADD " + (min - cans) + " MORE (MIN " + min + ")";
        if (total) total.style.display = "none";
      } else {
        if (label) label.textContent = "CHECKOUT";
        if (total) total.style.display = "";
      }
    }

    reconcile() {
      if (this._syncing) return;
      var data = cartData(), c = cfg(), ids = canVariantIds();
      var items = data.items || [];
      var sub = isSubscription(data), cans = totalCans(data), tier = tierFor(cans, sub);
      var actions = [];

      if (sub && tier && c.subPlans && c.subPlans[tier.key]) {
        var wantPlan = Number(c.subPlans[tier.key]);
        items.forEach(function (it) {
          if (isCanLine(it, ids) && Number(it.selling_plan) !== wantPlan) {
            actions.push({ op: "plan", key: it.key, quantity: it.quantity, selling_plan: wantPlan });
          }
        });
      } else if (sub && !tier) {
        items.forEach(function (it) {
          if (isCanLine(it, ids) && it.selling_plan) {
            actions.push({ op: "plan", key: it.key, quantity: it.quantity, selling_plan: null });
          }
        });
      }

      var giftLines = items.filter(function (it) { return it.is_gift; });
      var nonGift = items.filter(function (it) { return !it.is_gift; });
      var wantQty = tier ? (tier.gift || 0) : 0;
      var giftAddIds = [];
      nonGift.forEach(function (it) {
        (it.gift_add || []).forEach(function (id) { if (giftAddIds.indexOf(Number(id)) === -1) giftAddIds.push(Number(id)); });
      });
      var wantVariant = giftAddIds.length ? giftAddIds[0] : null;
      var matched = null;
      giftLines.forEach(function (g) {
        var wanted = wantVariant && Number(g.variant_id) === wantVariant && wantQty > 0;
        if (wanted) { matched = g; if (g.quantity !== wantQty) actions.push({ op: "change", key: g.key, quantity: wantQty }); }
        else { actions.push({ op: "change", key: g.key, quantity: 0 }); }
      });
      if (wantVariant && wantQty > 0 && !matched) actions.push({ op: "add", id: wantVariant, quantity: wantQty });

      if (!actions.length) return;
      this._syncing = true;
      internalAdd = true;
      var self = this, chain = Promise.resolve();
      actions.forEach(function (a) {
        chain = chain.then(function () {
          var url, body;
          if (a.op === "add") { url = "/cart/add.js"; body = { id: a.id, quantity: a.quantity }; }
          else if (a.op === "plan") { url = "/cart/change.js"; body = { id: a.key, quantity: a.quantity, selling_plan: a.selling_plan }; }
          else { url = "/cart/change.js"; body = { id: a.key, quantity: a.quantity }; }
          return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) });
        });
      });
      chain.then(function () { self._syncing = false; internalAdd = false; return self.refresh(); })
        .catch(function (e) { self._syncing = false; internalAdd = false; console.error("[cc] reconcile", e); });
    }
  }
  if (!customElements.get("custom-cart")) customElements.define("custom-cart", CustomCart);

  document.addEventListener("click", function (e) {
    var t = e.target.closest('[aria-controls="CartDrawer"], .cart-drawer-button, [data-cc-open], a[href$="/cart"], a[href*="/cart?"]');
    if (!t) return;
    var cart = document.querySelector("custom-cart");
    if (cart) { e.preventDefault(); e.stopPropagation(); document.dispatchEvent(new Event("cart::open")); }
  }, true);

  window.VoltaCart = {
    open: function () { document.dispatchEvent(new Event("cart::open")); },
    refresh: function () { document.dispatchEvent(new Event("cart::refresh")); }
  };
})();
